/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "@mui/styled-engine-sc";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";

const StyledListItemSecondaryAction = styled(({ ...props }) => <ListItemSecondaryAction {...props} />)`
  ${({ theme }) => `
  `}
`;

export { StyledListItemSecondaryAction };
